import { render, staticRenderFns } from "./roleManagementComponent.vue?vue&type=template&id=525c335d&scoped=true&"
import script from "./roleManagementComponent.vue?vue&type=script&lang=js&"
export * from "./roleManagementComponent.vue?vue&type=script&lang=js&"
import style0 from "./roleManagementComponent.vue?vue&type=style&index=0&id=525c335d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525c335d",
  null
  
)

export default component.exports